/**
 * Created by m.igrachev on 7/20/2017.
 */
import isClickOutside from "./isClickOutside";
import debounce from "./debounce";
import { debounceOngoing } from "./debounce";

export default {
    isClickOutside,
    debounce,
    debounceOngoing
};
